import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DataEndpoint } from '@core/models/general.model';
import { Observable, map } from 'rxjs';
import { OfficeDetailModel, OfficePaginatedModel, OfficePaginatedRequestModel, OfficeCreateRequestModel, OfficeUpdateRequestModel } from '../models/office.model';
import { HttpUtils } from '@core/utils/http.utils';

@Injectable({
  providedIn: 'root',
})
export class OfficeApi {
  private readonly http = inject(HttpClient);
  private readonly OFFICE = '/Office';

  getOfficeList(request: OfficePaginatedRequestModel): Observable<DataEndpoint<OfficePaginatedModel>> {
    const url = this.OFFICE;
    const params = HttpUtils.objectToHttpParams(request);

    return this.http.get<DataEndpoint<OfficePaginatedModel>>(url, { params })
      .pipe(map((data: DataEndpoint<OfficePaginatedModel>) => {
        return {...data}
      }));
  }

  getOfficeById(id: string): Observable<DataEndpoint<OfficeDetailModel>> {
    const url = `${this.OFFICE}/GetOfficeById/${id}`;

    return this.http.get<DataEndpoint<OfficeDetailModel>>(url)
      .pipe(map((data: DataEndpoint<OfficeDetailModel>) => {
        return {...data}
      }));
  }

  createOffice(request: OfficeCreateRequestModel[]): Observable<DataEndpoint<any>> {
    const url = `${this.OFFICE}/CreateOffice`;

    return this.http.post<DataEndpoint<any>>(url, request)
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      }));
  }

  updateOffice(id: string, request: OfficeCreateRequestModel): Observable<DataEndpoint<any>> {
    const url = `${this.OFFICE}/UpdateOffice/${id}`;

    return this.http.put<DataEndpoint<any>>(url, request)
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      }));
  }

  updateOfficeStatus(id: string): Observable<DataEndpoint<any>> {
    const url = `${this.OFFICE}/${id}/status`;

    return this.http.patch<DataEndpoint<any>>(url, {})
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      }));
  }
}